import type { FunctionComponent } from 'react';
import { currency } from '../../../../utils/currency';
import DefaultImage from '../../shared-components/DefaultImage/DefaultImage';
import defaultImage from './default-image.png';
import { ReactComponent as SurpriseMeIcon } from './surprise-me-icon.svg';
import * as styles from './styles.module.scss';

type ProductProps = {
  name: string;
  brandName?: string | null;
  title?: string | null;
  imageUrl?: string | null;
  price?: number | null;
  quantity?: number | null;
  autoAssigned?: boolean;
  slug?: string | null;
};

const Product: FunctionComponent<ProductProps> = ({
  name,
  brandName = null,
  title = null,
  imageUrl = null,
  price = null,
  quantity = null,
  autoAssigned = false,
  slug = null,
}) => {
  const productName = brandName ? `${brandName} ${name}` : name;
  const displayedName = autoAssigned ? 'Mystery Surprise' : productName;
  const productUrl = slug ? `/product/${slug}` : null;

  return (
    <li className={styles.product} data-testid="product-list-item">
      <div>
        {autoAssigned ? (
          <SurpriseMeIcon className={styles.surprise} />
        ) : (
          <a href={productUrl} target="_blank" rel="noreferrer">
            <figure>
              <DefaultImage src={imageUrl} defaultImage={defaultImage} alt={displayedName} />
            </figure>
          </a>
        )}
      </div>
      <div className={styles.productText}>
        <h3>{displayedName}</h3>
        {quantity && (
          <p data-testid="product-quantity-price">
            Qty: {quantity}
            <span>|</span>
            {currency.format(price)}
          </p>
        )}
        {title && <p>{title}</p>}
      </div>
    </li>
  );
};

export default Product;
